<template>
    <div class="wrap">
        <el-page-header @back="core.goBack" ></el-page-header>
        <!-- 项目介绍+课前预习 -->
        <div class="nav_wrap">
            <div class="introduce">项目介绍</div>
            <div class="preview" @click="toCourse">课前预习</div>
        </div>
        
        <!-- 项目介绍文字 -->
        <div class="project_wrap">
            <div class="project_title">{{title}}</div>
            <div class="peoject_content">
                <div class="content_text" v-html="contentText"></div>
                <!-- <div class="back_index" @click="toIndex"><i class="iconfont icon-home"></i></div> -->
            </div>
        </div>

        <!-- 选择期权模式（基础+挑战） -->
        <div class="select_wrap" v-if="isFuture == 0">
            <div class="select_item" @click="toNext(2)">
                <div class="select_title two_title">基础实验：期货套期保值交易策略</div>
                <div class="icon_two icon_wrap"><i class="iconfont icon-arrowRight"></i></div>
            </div>
            <div class="select_item" @click="toNext(3)">
                <div class="select_title two_title">进阶实验：期货套利交易策略</div>
                <div class="icon_two icon_wrap"><i class="iconfont icon-arrowRight"></i></div>
            </div>
        </div>

        <div class="select_wrap" v-else>
            <div class="select_item" @click="toEvaluation(1,2)">
                <div class="select_title two_title">基础实验：单期权套期保值交易策略</div>
                <div class="icon_two icon_wrap"><i class="iconfont icon-arrowRight"></i></div>
            </div>
            <div class="select_item" @click="toEvaluation(1,3)">
                <div class="select_title two_title">进阶实验：双限套期保值交易策略</div>
                <div class="icon_two icon_wrap"><i class="iconfont icon-arrowRight"></i></div>
            </div>
            <div class="select_item" @click="toEvaluation(1,4)">
                <div class="select_title two_title">挑战实验：期权套利交易策略</div>
                <div class="icon_two icon_wrap"><i class="iconfont icon-arrowRight"></i></div>
            </div>
        </div>

        <!-- 答题弹框 -->
        <el-dialog :visible.sync="evaluationVisible" width="50%" :modal-append-to-body="false" custom-class="question_wrap" center :close-on-click-modal="false" :show-close="false">
            <div class="question_title">
                本轮题目
            </div>
            <div class="question_content">
                <div class="question_notice_wrap">
                    <div>
                        <el-divider direction="vertical"></el-divider>
                        <span style="font-weight:bold">{{question.questionTypeName}}</span>
                    </div>
                    <div class="countdown flex-center">
                        <img src="../../assets/img/hourglass.png" alt="">
                        <span>倒计时：{{countdown}}</span>
                    </div>
                    <div>
                        <i class="iconfont icon-dengpao" v-if="passExam"  @click="innerVisible = true">&nbsp;&nbsp;查看提示</i>
                        <span>
                           <span style="color:#3595F9;font-size:25px">{{question.currentQuestionSortNo}}</span>/{{question.totalQuestionNum}}
                        </span>
                    </div>
                </div>
                <div class="question_text">
                        {{question.currentQuestionSortNo}}.{{question.questionStem}}
                </div>
                <ol class="question_item_wrap" :class="{isDone}">
                    <div class="question_label" v-for="(item,key) in question.options" :key="key" >
                        <div
                            @click.prevent="selectOption(key)"
                            :class="[{
                                select_item:selected.includes(key),
                                error_item:key == question.answer &&  selected.includes(key) && isCommit,
                                correct_item:key == question.answer  &&  selected.includes(key) && isCommit
                            },'question_item_label']"
                        >
                            <li>{{item}}</li>
                        </div>
                        <div v-if="isCommit" class="icon_wrap">
                            <i v-if="key == question.answer &&  selected.includes(key)" style="color: #109731;" class="el-icon-check check_icon"></i>
                            <i v-if="key != question.answer &&  selected.includes(key)" style="color: #FF2020;" class="el-icon-close close_icon"></i>
                        </div>
                    </div>
                </ol>
                <div v-if="isCommit" >
                    <div class="question_notice_wrap">
                    <div>
                        <el-divider direction="vertical"></el-divider>
                        <span style="font-weight:bold">答题解析</span>
                    </div>
                    <div></div>
                    </div>
                    <div>
                    <div class="correct_text">
                        <span>正确答案：</span> <span v-html="question.answer"></span>
                    </div>
                    <div class="question_text" v-html="question.answerAnalysis"></div>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer" v-if="!isDone">
                    <template v-if="lastOne">
                        <el-button type="primary" @click="submitQues">完成</el-button>
                    </template>
                    <template v-else>
                        <el-button class="second" type="primary" v-if="!isCommit" @click="changeCommit">提交</el-button>
                        <el-button class="second" type="primary" v-if="isCommit" @click="nextQues">下一题</el-button>
                    </template>
                    <el-button class="pass" @click="passQues" v-if="passExam">跳过测评</el-button>
                </div>
            </div>
            
            <el-dialog width="35%" top="10%" :modal="false" :visible.sync="innerVisible" append-to-body>
                    <div class="notice_wrap">
                        <div class="notice_icon">
                            <div><i class="iconfont icon-dengpao"></i></div>
                            <div>提示</div>
                        </div>
                        <div class="notice_text" v-html="question.answerAnalysis"></div>
                        <div class="notice_button">
                            <el-button @click="innerVisible = false" type="primary">知道了</el-button>
                        </div>
                    </div>
            </el-dialog>
        </el-dialog>

        <!-- 提交成绩弹框 -->
        <el-dialog :visible.sync="resultVisible" width="30%" custom-class="result_dialog" center :close-on-click-modal="false" :append-to-body="true">
            <div class="result"><span>{{result.isPassed}}</span></div>

            <div class="content">
                <div class="point">
                    <span>{{result.totalScore}}</span>分
                </div>
                <p class="tips">{{result.isPassed == '通过' ? '恭喜' : ''}}你答对{{result.correctQuestionNum}}题，正确率{{result.correctRate}}！</p>
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button class="first" @click="toEvaluation(0)">再试一次</el-button>
                <el-button class="second" type="primary" @click="getDetail">成绩详情</el-button>
                <el-button v-if="result.isPassed == '通过'" class="third" type="primary" @click="toSonSys">进入实训</el-button>
            </div>
        </el-dialog>

        <!-- 成绩详情弹框 -->
        <el-dialog :visible.sync="detailVisible" width="30%" custom-class="detail_dialog" center :close-on-click-modal="false" :append-to-body="true">
            <div class="title">成绩详情</div>
            <div style="min-height: 370px">
                <el-table
                    :data="detailData"
                    height="340"
                    border
                    style="width: 100%">
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="date" label="正误" min-width="45" align="center">
                        <template slot-scope="scope">
                            <img v-if="scope.row.questionScore" width="15" src="../../assets/img/true.png" alt="">
                            <img v-else width="15" src="../../assets/img/false.png" alt="">
                        </template>
                    </el-table-column>
                    <el-table-column prop="questionScore" label="得分" min-width="45" align="center"></el-table-column>
                    <el-table-column prop="answer" label="正确答案" min-width="70" align="center"></el-table-column>
                    <el-table-column prop="userAnswer" label="你的答案" min-width="70" align="center"></el-table-column>
                    <!-- <el-table-column prop="answerAnalysis" label="解析" min-width="80"></el-table-column> -->
                </el-table>
            </div>
            <p class="total">得分：{{totalScore}}分</p>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            innerVisible:false,
            isCommit:false,
            isFuture:Number(this.$route.query.isFuture),
            title:'',
            contentText:'',
            passExam: JSON.parse(sessionStorage.getItem('isTeacher')),
            userId: this.$store.state.userId,
            evaluationVisible: false,
            resultVisible: false,
            detailVisible: false,
            lastOne: false,
            question: {
                options: {}
            },
            countdown: '',
            selected: '',
            result: {},
            detail: {},
            timer: null,
            totalScore: 0,
            detailData: [],
            isDone: false,
            history: [],
            btnType: 1,
            showProject: false,
            evaluatetype:'',
        };
    },
    watch: {
        question: {
            handler(newVal,oldVal) {
                for(let n in newVal.options) {
                    if(newVal.options[n] == '') delete(newVal.options[n])
                }
            },
            deep: true
        }
    },
    mounted(){
       JSON.parse(sessionStorage.getItem('isTeacher')) && (this.passExam = JSON.parse(sessionStorage.getItem('isTeacher')))
        this.getText()
        //vuex中state中我定义了answerHistory为空数组，但是第一次加载时会出现undefined，需要价值后才会载入，肯定有什么地方存在缺陷
        if(typeof this.$store.state.answerHistory == "undefined"){
            location.reload()
        }
    },
    methods: {
        changeCommit(){
            if(!this.selected) return this.$message.error('请选择答案')
            this.isCommit = !this.isCommit
        },
        getText(){
            if(this.isFuture == 0){
                this.title = '期货交易虚拟仿真实验'
                this.contentText = '<p>本项目构建了面向实战的期货交易场景，分为期货套期保值和期货套利两个实验模块。学生通过商品期货（豆粕）和金融期货（股指）的相关实验，深入理解期货市场的两大功能：一是价格发现，投资者可以准确掌握未来市场的供求信息，提高资本市场的效率；二是风险规避，投资者可以通过套期保值来规避市场价格风险，促进金融服务实体经济的重要功能。</p>'
            }else{
                this.title = '期权交易虚拟仿真实验'
                this.contentText = '<p>本项目构建了面向实战的期权交易场景，分为单期权套期保值、双限套期保值和期权套利交易三个实验模块。套期保值实验让学生理解商品期权套期保值在稳定企业生产成本、进行风险管理的重要作用；套利实验让学生理解股指期权套利的目的除了让投资者获取盈利外，更重要的是为了纠正市场的定价误差，提高资本市场的效率，达到金融服务实体经济的目的。</p>'
            }
        },
        toIndex() {
            this.$router.push('dashboard')
        },
        toCourse() {
            this.$router.push({path:`dashboard#1`,query:{
                isFuture:this.isFuture
            }})
        },
        toNext(index) {
            //index == 2,为期货套保
            //index == 3,为期货套利
            this.$router.push(`ProjectPattern?pattern=${index}`)
        },
        
        async toEvaluation(type,btn) {
            clearInterval(this.timer)
            this.isCommit = false
            this.lastOne = false
            this.selected = ''
            this.resultVisible = false
            this.history = []
            if(btn) this.btnType = btn
            //type为真时进入实验，为假时
            if(type && !this.passExam){
                let res = await this.$get(this.api.openExerciseOrTeaching, { userId: this.userId })
                if(res.errmessage == 'true'){
                    //btn == 2为单个期权，模式对应为0
                    //btn == 3为多个期权，模式对应为1
                    //btn == 4为期权交易，模式对应为4
                    this.toNext(this.btnType == 2 ? 0 : this.btnType == 3 ? 1: 4)
                }else{
                    this.$alert('请先完成能力测评并达到80分以上才可以进行实验', '提示', {
                        confirmButtonText: '进入测评',
                        callback: action => {
                            if(action == 'confirm') this.toEvaluation(0)
                        }
                    });
                }
            }else{
                this.start()
                this.getCountdown()
            }
        },
        handleQues() {
            this.question.options = {}
            for(let n in this.question) {
                if(n.includes('option') && n != 'options') {
                    this.question.options[n.replace('option','')] = this.question[n]
                }
            }
            if(this.question.currentQuestionSortNo == this.question.totalQuestionNum){
                this.lastOne = true
            }else{
                this.lastOne = false
            }
        },
        async start() {
            let res = await this.$get(this.api.experimentStart, { userId: this.userId,types: Boolean(this.isFuture) ? 2 : 1  })
            if(res.data){
                this.question = res.data
                this.isDone = false
                this.question.currentQuestionSortNo == 1 && this.$store.commit("answerHistoryData", { answerHistory : []})
                this.handleQues()
                this.evaluationVisible = true
            }else{
                this.$message.warning(res.message)
            }
        },
        async getCountdown() {
            let res = await this.$get(this.api.experimentRemaining, { userId: this.userId })
            res.data && this.countDown(res.data)
            // this.countDown('00:00:05')
        },
        countDown(time) {
            this.countdown = time
            this.timer = setInterval(() => {
                let timeList = this.countdown.split(':')
                let total = Number.parseInt(timeList[1] * 60) + Number.parseInt(timeList[2])
                if(total > 0){
                    --total
                    let minutes = Math.floor(total / 60)
                    let seconds = Math.floor(total % 60)
                    this.countdown = `00:${this.core.formateTime(minutes)}:${this.core.formateTime(seconds)}`
                }else{
                    this.isDone = true
                    this.$message.warning('测评时间结束');
                    clearInterval(this.timer)
                    !this.selected && (this.selected = 'NaN')
                    this.submitQues()
                }
            },1000)
        },
        selectOption(option) {
            if(this.isCommit) return this.$message.error('请勿重新答题！！')
            if(!this.isDone) {
                if(this.selected.includes(option)) {
                    this.selected = this.selected.replace(option,'')
                }else{
                    if(this.question.questionType == 2) {
                        this.selected += option
                    }else{
                        this.selected = option
                    }
                }
            }
        },
        getHistory() {
            this.history = this.$store.state.answerHistory
        },
        async nextQues() {
            this.history = this.$store.state.answerHistory
            if(this.history.length > this.question.currentQuestionSortNo){
                this.history[this.question.currentQuestionSortNo-1] = this.selected
            }else if(this.history.length < this.question.currentQuestionSortNo){
                this.history.push(this.selected)
            }
            this.$store.commit("answerHistoryData", { answerHistory : this.history})
            let res = await this.$post(this.api.experimentNext, { 
                id: this.question.id,
                currentQuestionSortNo: this.question.currentQuestionSortNo,
                userAnswer: this.selected
            })
            if(res.data){
                this.question = res.data
                this.selected = ''
                if(this.history.length >= this.question.currentQuestionSortNo){
                    this.selected = this.history[this.question.currentQuestionSortNo-1]
                }else{
                    this.selected = ''
                }
                this.handleQues()
            }
            this.isCommit = false
        },
        async prevQues() {
            if(this.question.currentQuestionSortNo > 1){
                this.getHistory()
                let res = await this.$post(this.api.experimentPrevious, { 
                    id: this.question.id,
                    currentQuestionSortNo: this.question.currentQuestionSortNo,
                    userAnswer: this.selected
                })
                if(res.data){
                    this.question = res.data
                    this.selected = this.history[this.question.currentQuestionSortNo-1]
                    this.handleQues()
                }
            }
        },
        async submitQues() {
            if(!this.selected) return this.$message.warning('请选择答案');
            let res = await this.$post(this.api.experimentSubmit, { 
                id: this.question.id,
                currentQuestionSortNo: this.question.currentQuestionSortNo,
                userAnswer: this.selected,
                userId: this.userId,
                types: Boolean(this.isFuture) ? 2 : 1
            })
            if(res.data) {
                this.result = res.data
                this.evaluationVisible = false
                this.resultVisible = true
            }
        },
        async passQues(){
            this.$post(this.api.experimentSubmit, {
                id: this.question.id,
                currentQuestionSortNo: this.question.currentQuestionSortNo,
                userAnswer: this.selected,
                userId: this.userId,
                types:  Boolean(this.isFuture) ? 2 : 1
            }).then(res => {
                this.resultVisible = false
                //btn == 2为单个期权，模式对应为0
                //btn == 3为多个期权，模式对应为1
                //btn == 4为期权交易，模式对应为4
                this.toNext(this.btnType == 2 ? 0 : this.btnType == 3 ? 1: 4)
            }).catch(err => {})
        },
        async getDetail() {
            let res = await this.$get(this.api.experimentDetail, { 
                evaluationRecordId: this.question.id
            })
            if(res.data){
                this.totalScore = res.data.totalScore
                this.detailData = res.data.evaluationDetailVOS
                this.resultVisible = false
                this.detailVisible = true
            }
        },
        toSonSys() {
            this.resultVisible = false
            this.toNext(this.btnType == 2 ? 0 : this.btnType == 3 ? 1: 4)
        }
    },
};
</script>
<style lang="scss" scoped>
.dialog-footer{
    text-align: center;
}
/deep/.el-dialog.question_wrap {
    border-radius: 25px;
    overflow: hidden;
    color: black;
    box-sizing: border-box;
    font-size: 20px;
    width: 430px;
    background: none;
    letter-spacing: 1px;
    font-family: "微软雅黑";
    background-size: 100% 100%;
    .correct_text{
            font-size: 22px;
            span{
                font-weight: 600;
            }
        }
    .question_notice_wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        font-size: 22px;
        .el-divider--vertical{
            width: 7px;
            height: 30px;
            background: #3A95F6;
        }
        .icon-dengpao{
            color: #FC8428 ;
            font-size: 20px;
            margin-right: 20px;
        }
        .icon-dengpao:hover{
            cursor: pointer;
            opacity: 0.6;
        }
        
    }
    .question_content{
        background: white;
        padding: 10px 8%;
    }
    .el-dialog__header{
        padding: 0px;
    }
    
    .el-dialog__body{
        padding: 0px;
        .question_title{
            height: 70px;
            width: 100%;
            background: url('../../assets/img/question_title.png') 0 0/100% 100% no-repeat;
            text-align: center;
            color: white;
            font-size: 28px;
            line-height: 60px;
            letter-spacing: 2px;
            font-weight: 550;
        }
        .question_text{
            padding: 15px 0px;
            font-size: 20px;
            line-height: 1.7;
        }
        .question_item{
            padding-top: 20px;
            width: 100%;
            height: 190px;
            font-size: 18px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        
        .question_item_wrap{
            padding: 30px 0px;
            width: 100%;
            
            .question_label{
                align-items: center;
                width: 80%;
                display: flex;
                justify-content: center;
                margin: auto;
                
                .question_item_label{
                    width: 60%;
                    padding: 10px 30px 10px 60px;
                    margin: 10px 0px;
                    border: 1px solid #C0C0C0;
                    border-radius: 4px;
                    color: #8F8F8F;
                    box-sizing: border-box;
                    margin-right: 20px;
                }
                .question_item_label:hover{
                    cursor: pointer;
                    box-shadow: 1px 1px 4px rgba(125, 168, 255, 0.8);
                    background: #E7F2FF;
                    border: 1px solid #3794F9;
                }
                .icon_wrap{
                    width: 60px;
                }
                .select_item{
                    cursor: pointer;
                    box-shadow: 1px 1px 4px rgba(125, 168, 255, 0.8);
                    background: #E7F2FF;
                    border: 1px solid #3794F9;
                }
                .error_item{
                    background: #FFB7B7;
                    border: 1px solid #FF2020;
                    box-shadow: 1px 1px 4px rgba(255, 59, 59, 0.8);
                }
                .correct_item{
                    background: #B3E4BF;
                    border: 1px solid #109731;
                    box-shadow: 1px 1px 4px rgba(62, 133, 79, 0.8);
                }
                .check_icon{
                    font-size: 25px;
                    color: #109731;
                }
                .close_icon{
                    font-size: 25px;
                    color: #FF2020;
                }
                li{
                    font-size: 18px;
                    list-style-type: upper-alpha;
                }
            }
        }
    }
    .commit{
        text-align: center;
        color: white;
        margin: 20px auto;
        letter-spacing: 3px;
        font-size: 24px;
        
    }
    .commit:hover{
        opacity: 0.8;
        cursor:pointer
    }
    
    
    .footnote{
        text-align: right;
    }
}
.notice_wrap{
    padding: 0px 50px;
    width: 100%;
    box-sizing: border-box;
    .notice_icon{
        text-align: center;
        color: #FC8428;
        font-size: 22px;
        letter-spacing: 3px;
        .icon-dengpao{
            font-size: 88px;
            margin-bottom: 20px;
        }
    }
    .notice_text{
        text-indent: 2rem;
        line-height: 1.8;
        font-size: 18px;
    }
    .notice_button{
        text-align: center;
        margin: 10px 0px;
    }
}
.wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    background: url('../../assets/img/introBg.jpg') no-repeat;
    background-size: 100% 100%;
}
.nav_wrap{
    height: 50px;
    display: flex;
    justify-content: center;
    color: white;
    .introduce{
        background: #004590;
    }
    div{
        width: 200px;
        line-height: 50px;
        text-align: center;
        font-size: 26px;
        cursor: pointer;
    }
    div:hover{
        opacity: 0.8;
    }
    .preview{
        background: #FF5288;
    }
}
.project_wrap{
    width: 100%;
    // padding-left: 200px;
    box-sizing: border-box;
    .project_title{
        width: 50%;
        text-align: center;
        height: 80px;
        margin-top: 70px;
        font-size: 65px;
        color: #FF5288;
        font-weight: 600;
    }
    .peoject_content{
        height: 500px;
        margin-top: 20px;
        // background: red;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content_text{
            box-sizing: border-box;
            text-align: justify;
            text-indent: 4rem;
            letter-spacing:2px;
            height: 500px;
            width: 50%;
            background: white;
            padding: 80px ;
            box-sizing: border-box;
            color: #242323;
            line-height: 1.6;
            font-size: 26px;
            font-weight: 60;
            font-family: '微软雅黑';
        }
        .back_index{
            width: 80px;
            height: 80px;
            background: white;
            text-align: center;
            .icon-home{
                font-size: 50px;
                color: #FF5288;
                font-weight: 600;
                line-height: 80px;
            }
        }
        .back_index:hover{
            // background: #3f7ecc;
            opacity: 0.8;
            cursor: pointer;
        }
    }
   
}
.select_wrap{
    position: absolute;
    right: 3vw;
    top:50%;
    transform: translateY(-50%);
    .select_item{
        width: 600px;
        display: flex;
        cursor: pointer;
        justify-content: flex-end;
        margin-bottom: 40px;
        .icon_wrap{
            width: 60px;
            height: 60px;
            text-align: center; 
            margin-left: 20px;
        }
        .select_title{
            font-size: 27px;
            line-height: 60px;
            letter-spacing:3px;
        }
        .one_title{
            color: #004590;
        }
        .two_title{
            color: white;
        }
        .three_title{
            color: #FF5288;
        }
        .icon_one{
            background: #004590;
        }
        .icon_two{
            background: #FF5288;
        }
    }
    .select_item:hover{
        opacity: 0.8;
        .icon_two{
            background: #004590;
        }
    }
}
.analysis_wrap{
    height: 120px;
    overflow-y:scroll ;
    font-size: 16px;
    line-height: 1.6;
    em{
        font-weight: 600;
        font-style: normal;
    }
}
.icon-arrowRight{
    font-size: 50px;
    color: white;
    line-height: 60px;
}

/deep/.el-tabs__item:focus{
    outline: none;
    box-shadow: none !important;
}
.back_index:hover{
    opacity: 0.8;
    cursor: pointer;
}
.back_index{
    position: fixed;
    right: 0px;
    top: 48%;
    width: 80px;
    height: 80px;
    background: white;
    text-align: center;
    z-index: 100;
}
.icon-home{
    font-size: 50px;
    color: #FF5288;
    font-weight: 600;
    line-height: 80px;
}
h3{
    color: #328aff;
    margin-bottom: 10px;
}
.mar0{
    margin-top: 0;
}
/deep/.evaluation_dialog{
    min-height: 700px;
    background: url(../../assets/img/evaluation_bg1.png) 0 0/100% 100% no-repeat;
}
/deep/.evaluation_dialog .el-dialog__headerbtn,/deep/.evaluation_dialog .el-dialog__headerbtn,/deep/.detail_dialog .el-dialog__headerbtn{
    font-size: 28px;
}
/deep/.evaluation_dialog .title,/deep/.detail_dialog .title{
    margin-bottom: 45px;
    text-align: center;
    font-size: 24px
}
/deep/.evaluation_dialog .title{
    margin-bottom: 55px;
}
/deep/.evaluation_dialog .serial{
    font-size: 12px;
    text-align: center;
}
/deep/.evaluation_dialog .content{
    width: 80%;
    margin: 0 auto;
}
/deep/.evaluation_dialog .type{
    color: #666;
}
/deep/.evaluation_dialog .ques{
    margin: 20px 0;
    min-height: 145px;
    color: #666;
    font-size: 16px;
}
/deep/.evaluation_dialog .countdown{
    margin-bottom: 20px;
    justify-content: center;
    text-align: center;
    color: #DC3434;
    font-size: 14px;
}
/deep/.evaluation_dialog .countdown img{
    width: 15px !important;
    margin-right: 10px;
}
/deep/.evaluation_dialog .options{
    display: flex;
    flex-direction: column;
    // min-height: 340px;
}
/deep/.evaluation_dialog .option_wrap{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 40px;
    .question_option{
        width: 100%;
    }
    .icon_wrap{
        width: 30px;
        margin-left: 30px;
    }
    .check_icon,.close_icon{
        font-size: 25px;
    }
}
/deep/.evaluation_dialog .options.isDone{
    min-height: 395px;
}
/deep/.evaluation_dialog .options .question_option{
    padding: 0 15px;
    margin: 8px 0px;
    line-height: 40px;
    border: 1px solid #9070FF;
    border-radius: 20px;
    color: #666;
    cursor: pointer;
}
/deep/.evaluation_dialog .options .question_option:hover{
    color: #fff;
    background-color: #b038bb;
    border-color: #b038bb;
}
/deep/.evaluation_dialog .options .option_wrap .active{
    color: #fff;
    background-color: #916CFF;
    border-color: #916CFF;
}
/deep/.evaluation_dialog .options em{
    margin-right: 10px;
    font-weight: bold;
    font-style: normal;
    font-size: 16px;
}
/deep/.evaluation_dialog .options span{
    font-size: 16px;
}
/deep/.evaluation_dialog .el-dialog__footer{
    text-align: center;
}
/deep/.evaluation_dialog .first,/deep/.result_dialog .first{
    color: #fff;
    background-color: #9268FF;
    border-color: #9268FF;
}
/deep/.evaluation_dialog .second,/deep/.result_dialog .second{
    color: #fff;
    background-color: #E371DA;
    border-color: #E371DA;
}
/deep/.evaluation_dialog .pass,/deep/.result_dialog .pass{
    color: #fff;
    background-color: #e42c85;
    border-color: #e42c85;
}

/deep/.result_dialog{
    min-height: 500px;
    background: url(../../assets/img/evaluation_bg2.png) 0 0/100% 100% no-repeat;
}
/deep/.result_dialog .el-dialog__headerbtn .el-dialog__close{
    color: #5a5a5a;
    font-size: 28px;
}
/deep/.result_dialog .result{
    margin-top: 60px;
    text-align: center;
    color: #fff;
    font-size: 24px;
}
/deep/.result_dialog .point{
    margin: 30px 0 20px;
    text-align: center;
    font-size: 30px;
    color: #666;
}
/deep/.result_dialog .point span{
    font-size: 120px;
    font-weight: bold;
}
/deep/.result_dialog .tips{
    color: #666;
    text-align: center;
    font-size: 14px;
}
/deep/.result_dialog .third{
    color: #fff;
    background-color: #418cf5;
    border-color: #418cf5;
}

/deep/.detail_dialog{
    background: url(../../assets/img/evaluation_bg3.png) 0 0/100% 100% no-repeat;
}
/deep/.detail_dialog .title{
    margin-top: -20px;
}
/deep/.detail_dialog .el-table__header th:nth-last-child(2){
    text-align: center;
}
/deep/.detail_dialog .total{
    margin-top: 20px;
    text-align: center;
    font-size: 30px;
    color: #DC3434;
}
/deep/.evaluation_dialog{
    margin:0 !important;
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    max-height:calc(100% - 30px);
    max-width:calc(100% - 30px);
}

/deep/.evaluation_dialog .el-dialog__body{
    flex:1;
    overflow: auto;
}
</style>